import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const AUTH_PAGES = ["/login", "/signup", "/forgot-password", "/reset-password"];

// A dead session must always land on /login with a clear reason — never a silent blank screen.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const detail = error.response?.data?.detail;
    const url = error.config?.url || "";
    const isAuthProbe = url.startsWith("/auth/");
    if (error.response?.status === 401 && !isAuthProbe && !AUTH_PAGES.includes(window.location.pathname)) {
      localStorage.removeItem("cx_token");
      localStorage.removeItem("cx_user");
      const reason = detail === "SESSION_EXPIRED" ? "expired" : "auth";
      window.location.replace(`/login?reason=${reason}`);
      return new Promise(() => {}); // stop the rejection from bubbling while we navigate away
    }
    // Cross-company access is blocked server-side; bounce the user back to their own workspace
    // instead of letting the rejection surface as an uncaught error.
    if (error.response?.status === 403 && typeof detail === "string" && /another company/i.test(detail)) {
      window.location.replace("/projects");
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export async function downloadFile(path, filename) {
  const token = localStorage.getItem("cx_token");
  const res = await fetch(`${BASE}/api${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });
  if (!res.ok) throw new Error("Export failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
